import { Box, Typography } from "@mui/material"
import { useNavigate, useSearch } from "@tanstack/react-router"
import type { FC } from "react"
import React from "react"

import { FilterChip } from "@/components/common/Filters"
import type { ComputedProductStatus, ProductListFilter } from "@/graphql/codegen/graphql"
import SupplierFilterChips from "@/screens/Products/components/filters/SupplierFilterChips"
import { productStatusLabelMap } from "@/screens/Products/utils/productsTableConfig"

const ProductListFilterChips: FC = () => {
  const { computedProductStatuses = [], companyIds = [] } = useSearch({
    from: "/app/products/",
    strict: true,
  })
  const navigate = useNavigate({ from: "/app/products" })

  if (!computedProductStatuses.length && !companyIds.length) {
    return null
  }

  const handleClearFilter = (key: keyof ProductListFilter, value: string | ComputedProductStatus) => {
    navigate({
      search: (prev: ProductListFilter) => {
        const newFilter = { ...prev }

        if (Array.isArray(newFilter[key])) {
          ;(newFilter[key] as (string[] | ComputedProductStatus)[]) = (
            newFilter[key] as (string[] | ComputedProductStatus)[]
          ).filter((item) => item !== value)

          if (newFilter[key].length === 0) {
            newFilter[key] = undefined
          }
        }

        return newFilter
      },
      replace: true,
    })
  }

  return (
    <Box data-testid='products-filter-chips' display='flex' flexWrap='wrap' alignItems='center' gap={2}>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      {computedProductStatuses.map((item) => (
        <FilterChip
          key={`products-filter-chip-${item}`}
          label={`Status: ${productStatusLabelMap.get(item)}`}
          onDelete={() => handleClearFilter("computedProductStatuses", item)}
        />
      ))}
      {Boolean(companyIds.length) && (
        <SupplierFilterChips selectedSuppliers={companyIds} onRemove={handleClearFilter} />
      )}
    </Box>
  )
}
export default ProductListFilterChips
